// Bundle theme module
import NSTheme from './NSTheme';
import Helper from './Classes/Helper';
import Header from './Classes/Header';
import CategoryLoader from './Classes/CategoryLoader';
import FocusHandler from './Classes/FocusHandler';
import Jump from './Classes/Jump'
import ResponsiveTable from "./Classes/ResponsiveTable";
import LazyLoad from './Classes/Lazyload';
import NoLine from "./Classes/NoLine";
import smoothscroll from 'smoothscroll-polyfill';
import SustainabilityTabs from "./Classes/SustainabilityTabs";
import Swiper from "./lib/swiper"
import Anchor from "./Classes/Anchor";
import NoHeader from "./Classes/NoHeader";
import Parallax from './Classes/Parallax';
import Accordion from "./Classes/Accordion";
import Counter from "./Classes/Counter";
import CounterInSwiper from "./Classes/CounterInSwiper";
import newVideo from "./Classes/NewVideo";
import Video from './Classes/Video';
import SliderHandler from './Classes/SliderHandler';
import SliderArrowCenter from './Classes/SliderArrowCenter';
import AnchorPDF from "./Classes/AnchorPDF";
import IsIos from "./Classes/IsIos";
import KeyfigurePopup from "./Classes/KeyfigurePopup";

(function () {
  document.addEventListener('DOMContentLoaded', () => {

    const quoteSwiper = new Swiper('.swiper-container-quotes', {
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 500,

        navigation: {
            nextEl: '.swiper-button-next-quotes',
            prevEl: '.swiper-button-prev-quotes',
        },
        pagination: {
            el: '.swiper-pagination-quotes',
            clickable: true,
        },
        loop: true,

    });


    new KeyfigurePopup();
    new newVideo();
    new Video();

    new Accordion({
      accordions: '.lc-accordion__inner-head',
      pxCorrectionMobile: 110,
      pxCorrectionDesktop: 105,
      mobileBreakpoint: 1025
    });


    new IsIos();

    new Header();
    new CategoryLoader();
    new FocusHandler();
    new LazyLoad();

    new NoLine();
    new NoHeader();
    new Parallax();
    new SustainabilityTabs({
        tabButtonSelector: '.sustainability__button',
        tabSelector: '.sustainabiltity__tab'
      }
    );

    new Jump({
      graphicSelector: '.ns-graphic'
    });

    new AnchorPDF({
      anchorSelector: '.ns-anchor'
    });

    smoothscroll.polyfill();
    //new Anchor();

    new ResponsiveTable({
      tableSelector: '.ns-table-wrap table',
      tableWrapperSelector: '.ns-table-wrap',
      breakPointLg: 1200,
      breakPointMd: 768,
      breakPointSm: 480,
      colCountNoSplit: 3,
      colCountEarlyBreak: 7,
      noSplitArray: []
    });

    const sliderContainer = document.querySelector('.swiper-container');
    if (sliderContainer && sliderContainer != undefined) {
      Helper.loadImagesInDomElement(sliderContainer);
    }

    new Swiper('.swiper-outer .swiper-container', {
      direction: 'horizontal',
      loop: true,
      autoplay: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });




    /*
    new Swiper('.ns-keyfigures__inner', {
      direction: 'horizontal',
      loop: true,
      autoplay: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
    */

    var keyfigureInstance = new Swiper('.ns-keyfigures-slider:not(.content-width) .swiper-container', {
      // Default parameters
      touchEventsTarget: 'container',
      watchSlidesVisibility: true,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      keyboard: {
        enabled: true,
      },
      slidesPerView: 1,
      visibilityFullFit: true,
      spaceBetween: 0,
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 3
        },
        1201: {
          slidesPerView: 4
        }
      }
    });

    var keyfigureInstanceContentWidth = new Swiper('.ns-keyfigures-slider.content-width .swiper-container', {
      // Default parameters
      touchEventsTarget: 'container',
      watchSlidesVisibility: true,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      keyboard: {
        enabled: true,
      },
      slidesPerView: 1,
      visibilityFullFit: true,
      spaceBetween: 0,
      breakpoints: {
        // when window width is >= 320px
        768: {
          slidesPerView: 6
        }
      }
    });

    var counterInSwiperInstance = new CounterInSwiper({
      keyfigureInstance: keyfigureInstance,
      langArray: [
        'de-DE',
        'en-US',
        'fr-FR',
        'it-IT'
      ],
      decimalArray: [
        ',',
        '.',
        ',',
        ','
      ],
      thousandSepArray: [
        '',
        '',
        '',
        ''
      ]
    });

    var counterInSwiperInstanceContentWidth = new CounterInSwiper({
      keyfigureInstance: keyfigureInstanceContentWidth,
      langArray: [
        'de-DE',
        'en-US',
        'fr-FR',
        'it-IT'
      ],
      decimalArray: [
        ',',
        '.',
        ',',
        ','
      ],
      thousandSepArray: [
        '',
        '',
        '',
        ''
      ]
    });

    new Counter({
      container: '.ns-keyfigures:not(.ns-keyfigures--no-upcounting)',
      classIn: 'is-in-viewport',
      classOut: 'is-not-in-viewport',
      langArray: [
        'de-DE',
        'en-US',
        'fr-FR',
        'it-IT'
      ],
      decimalArray: [
        ',',
        '.',
        ',',
        ','
      ],
      thousandSepArray: [
        '',
        '',
        '',
        ''
      ]
    });

    //new Video();



    var sliderInstance = new SliderHandler({
      sliderType: 'slideWithTab',
      outerWrapperSelector: '.ns-slider-wrapper'
    });

    var swiperInstances = sliderInstance.getInstances();

    new SliderArrowCenter({
      outerWrapperSelector: '.ns-slider-wrapper',
      heightItem: '.swiper-slide-active .ns-slide-tile__image',
      swiperInstances: swiperInstances,
      sliderBreakpointMax: 768
    });


    // -- STARTPAGE SLIDER --


    let desktopSwiper = null;

    let mobileSwiperContainer = null;
    let mobileSwiper = null;

    function createDesktopSwiper() {
        desktopSwiper = new Swiper('.swiper-container-startpage', {
            direction: 'horizontal',
            loop: true,
            autoplay: {
              delay: 5000,
            },
            speed: 800,
            autoHeight: true,  // Adjust height to current slide
             pagination: {
                 el: '.swiper-pagination',
                 type: 'bullets',
                 clickable: true,
             },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 1,
            allowTouchMove: true,
        });
        window.desktopSwiper = desktopSwiper;
    }

    function createMobileSwiper() {
        if (mobileSwiperContainer) return;


        mobileSwiperContainer = document.createElement('div');
        mobileSwiperContainer.className = 'swiper-container-mobile';
        mobileSwiperContainer.innerHTML = `
            <div class="swiper-wrapper"></div>
        `;


        const desktopContainer = document.querySelector('.swiper-container-startpage__wrapper');
        desktopContainer.appendChild(mobileSwiperContainer);


        const itemContainers = document.querySelectorAll('.ns-keyfigure-new__item-container');
        itemContainers.forEach(container => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide';
            slide.appendChild(container.cloneNode(true));
            mobileSwiperContainer.querySelector('.swiper-wrapper').appendChild(slide);
        });

        const links = document.querySelector('.ns-keyfigure-new__links');
        if (links) {
            const clonedLinks = links.cloneNode(true);
            mobileSwiperContainer.appendChild(clonedLinks);
        }

        const pagination = document.createElement('div');
        pagination.className = 'swiper-pagination swiper-pagination-mobile';
        desktopContainer.appendChild(pagination);

        mobileSwiper = new Swiper(mobileSwiperContainer, {
            direction: 'horizontal',
            loop: true,
            autoplay: {
              delay: 5000,
            },
            speed: 800,
            autoHeight: true,
            // pagination: {
            //     el: pagination,
            //     type: 'bullets',
            //     clickable: true,
            // },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 1,
            allowTouchMove: true,
        });
        window.mobileSwiper = mobileSwiper;
    }

    function toggleSwipers() {
        const wrapper = document.querySelector('.swiper-container-startpage__wrapper');
        if (!wrapper) return;

        const isMobile = window.innerWidth <= 1040;
        const desktopContainer = document.querySelector('.swiper-container-startpage');
        const pagination = wrapper.querySelector('.swiper-pagination');

        if (isMobile) {

            if (desktopSwiper) {
                desktopSwiper.destroy();
                desktopSwiper = null;
                window.desktopSwiper = null;
            }

            if (!mobileSwiper) createMobileSwiper();
            desktopContainer.style.display = 'none';
            if (mobileSwiperContainer) mobileSwiperContainer.style.display = 'block';
            if (pagination) pagination.style.display = 'none';
        } else {

            if (mobileSwiper) {
                mobileSwiper.destroy();
                mobileSwiper = null;
                window.mobileSwiper = null;
                if (mobileSwiperContainer) mobileSwiperContainer.remove();
                mobileSwiperContainer = null;
                const mobilePagination = wrapper.querySelector('.swiper-pagination-mobile');
                if (mobilePagination) mobilePagination.remove();
            }
            if (!desktopSwiper) createDesktopSwiper();
            desktopContainer.style.display = 'block';
            if (mobileSwiperContainer) mobileSwiperContainer.style.display = 'none';
            if (pagination) pagination.style.display = 'block';
        }
    }

    toggleSwipers();

    window.addEventListener('resize', toggleSwipers);

  })
})();
